import { postRequest } from "../libs/AxiosService.util";

export async function serviceSequenceCreate(params) {
  return await postRequest("sequences/create", params);
}

export async function serviceSequenceUpdate(params) {
  return await postRequest("sequences/update", params);
}

export async function serviceSequenceList(params) {
  return await postRequest("sequences/list", params);
}

export async function serviceSequenceDetail(params) {
  return await postRequest("sequences/detail", params);
}

export async function serviceSequenceToggleActive(params) {
  return await postRequest("sequences/toggle-active", params);
}

export async function serviceSequenceEnroll(params) {
  return await postRequest("sequences/enroll", params);
}

export async function serviceSequenceStopEnrollment(params) {
  return await postRequest("sequences/stop-enrollment", params);
}

export async function serviceSequenceEnrollmentList(params) {
  return await postRequest("sequences/enrollment-list", params);
}

export async function serviceSequenceStepLogs(params) {
  return await postRequest("sequences/step-logs", params);
}
